import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQueryOperator]' })
export class QueryOperatorDirective
{
  constructor(public template: TemplateRef<any>) { }
}
